import { render } from "./CreatedModal.vue?vue&type=template&id=2077b9a4&scoped=true"
import script from "./CreatedModal.vue?vue&type=script&lang=js"
export * from "./CreatedModal.vue?vue&type=script&lang=js"

import "./CreatedModal.vue?vue&type=style&index=0&id=2077b9a4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2077b9a4"]])

export default __exports__